<template>
    <div>
    <div
      class="sh-main-button-play"
      @click.stop="dialog = true"
    >
      <span class="sh-main-button-text">Дивитись</span>
      <span class="sh-main-button-play--icon">
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0L11.5 7L0 14V0Z" fill="white"/>
        </svg>
      </span>
    </div>
  
    <v-dialog
      v-model="dialog"
      max-width="1280"
     
    >
      <v-card
        class="preview-video-song">
        <youtube :video-id="meetupYoutube"  :player-vars="playerVars" @playing="playing"></youtube>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  export default {
    props: ['meetupYoutube'],
    data () {
      return {
        dialog: false,
        playerVars: {
            autoplay: -1
        }
      }
    },
    methods: {
    playVideo() {
      this.player.destroy()
    },
    stop() {
      if (this.stopplay) {
        this.player.paused()
      }
    },
    playing() {
        console.log('\o/ we are watching!!!')
        }
    },
    computed: {
        stopplay () {
          this.dialog = false
        },
        player() {
        return this.$refs.youtube.player
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Modals/ModalVideo.vue